import { Box, useTheme } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import useDrawerState from '@/modules/common/application/useDrawerState';

import { Drawer, Loader } from '../../modules/common/components/Base';
import { DrawerContent } from '../../modules/common/components/Base/Drawer';

const AppLayout = () => {
  const { drawerOpen, toggleDrawer } = useDrawerState();
  const theme = useTheme();
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
      }}
    >
      <Drawer open={drawerOpen}>
        <DrawerContent drawerExpanded={drawerOpen} toggleDrawer={toggleDrawer} />
      </Drawer>
      <Box
        component="main"
        sx={{
          position: 'relative',
          overflow: 'hidden',
          flexGrow: 1,
          minHeight: '100vh',
          padding: theme.spacing(0, 4, 3, 3),
        }}
      >
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default AppLayout;
